import type { RouteRecordRaw } from 'vue-router';
import FullLayout from '@/layouts/full/FullLayout.vue';

export const cartaoCorporativoRoutes: RouteRecordRaw[] = [
  {
    path: '/cartao-corporativo',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Cartão Corporativo - Hub' },
    children: [
      {
        path: '',
        redirect: '/cartao-corporativo/dashboard-analista',
      },
      {
        path: 'analistaFinanceiro',
        name: 'CartaoAnalistaImportar',
        component: () => import('@/views/CartaoCorporativo/AnalistaUpload.vue'),
        meta: { title: 'Importar fatura', breadcrumb: 'Importar fatura' },
      },
      {
        // Gestor é livre: qualquer usuário autenticado vê apenas as faturas
        // atribuídas a si (sem permissão de rota). `freeForAuth` libera o guard.
        path: 'gestor',
        name: 'CartaoGestorInbox',
        component: () => import('@/views/CartaoCorporativo/GestorInbox.vue'),
        meta: { title: 'Minhas faturas', breadcrumb: 'Minhas faturas', freeForAuth: true },
      },
      {
        path: 'gestor/:faturaId(\\d+)',
        name: 'CartaoGestorClassificar',
        component: () => import('@/views/CartaoCorporativo/GestorClassify.vue'),
        props: true,
        meta: { title: 'Classificar lançamentos', breadcrumb: 'Classificar', freeForAuth: true },
      },
      {
        path: 'dashboard-analista',
        name: 'CartaoDashboard',
        component: () => import('@/views/CartaoCorporativo/DashboardAnalista.vue'),
        meta: { title: 'Dashboard Cartão Corporativo', breadcrumb: 'Dashboard' },
      },
    ],
  },
];

export default cartaoCorporativoRoutes;
